module.exports = fox._r("fonts/ostrich-sans-black.woff", __webpack_public_path__ + "_/_/_/root/fonts/27jba7p.woff");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/fonts/ostrich-sans-black.woff
// module id = 172
// module chunks = 4